import { VariantForm } from "@/components/products/VariantForm";
import { ProductAttribute } from "@/types/product-type";
import { ProductVariantCreateFormValues } from "@/types/product-variant-type";
import { VariantDialogShell } from "./variant-dialog-shell";

interface CreateVariantDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  productId: string;
  productCode: string;
  productAttributes: ProductAttribute[];
  onSubmit: (data: ProductVariantCreateFormValues) => Promise<void>;
  isLoading?: boolean;
}

export function CreateVariantDialog({
  open,
  onOpenChange,
  productId,
  productCode,
  productAttributes,
  onSubmit,
  isLoading = false,
}: CreateVariantDialogProps) {
  return (
    <VariantDialogShell
      open={open}
      onOpenChange={onOpenChange}
      title="Create New Variant"
      description="Add a new variant for this product with different attributes and pricing."
    >
      <VariantForm
        mode="create"
        productId={productId}
        productCode={productCode}
        onSubmit={async (data) => {
          await onSubmit(data as ProductVariantCreateFormValues);
        }}
        onCancel={() => onOpenChange(false)}
        isLoading={isLoading}
      />
    </VariantDialogShell>
  );
}
